module.exports = __webpack_public_path__ + "static/media/banner2.2a289d82.jpg";